// src/components/ContactUsPage/ContactUsPage.jsx
import React, { useState } from "react";
import { Row, Col, CardBody, Form, FormGroup, Label, Input } from "reactstrap";
import "../../assets/css/--component-customer-support.css";
import "../../assets/css/--component-contact-us.css";
import contactImg from "../../assets/images/auth-bg-image.png";
import sayHelo from "../../assets/images/Say Hello.png";
import { postSupportRequest } from "../../helper/backend-methods";
import ConfirmationModal from "../../components/StatusModal";

const ContactUs = () => {
  const [form, setForm] = useState({
    Name: "",
    Email: "",
    PhoneNumber: "",
    Subject: "",
    Message: "",
    AgreeToTerms: false,
    SubscribeToNewsletter: false,
  });

  const [errors, setErrors] = useState({
    Name: "",
    Email: "",
    PhoneNumber: "",
    Subject: "",
    Message: "",
    AgreeToTerms: "",
  });

  const [showAllErrors, setShowAllErrors] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const subjectOptions = ["Select", "General Inquiry", "Feedback", "Partnership", "Media", "Other"];

  const validateField = (name, value) => {
    let error = "";

    switch (name) {
      case "Name":
        if (!value.trim()) {
          error = "Full name is required";
        } else if (value.trim().length < 2) {
          error = "Full name must be at least 2 characters";
        } else if (value.trim().length > 60) {
          error = "Full name cannot exceed 60 characters";
        }
        break;

      case "Email":
        if (!value.trim()) {
          error = "Email address is required";
        } else if (!/\S+@\S+\.\S+/.test(value)) {
          error = "Please enter a valid email address";
        }
        break;

      case "PhoneNumber":
        if (!value.trim()) {
          error = "Phone number is required";
        } else {
          // US Phone number validation
          const phoneRegex = /^(\+1\s?)?(\(?\d{3}\)?[\s.-]?)?\d{3}[\s.-]?\d{4}$/;
          if (!phoneRegex.test(value)) {
            error = "Please enter a valid US phone number (e.g., 123-456-7890, (123) 456-7890, +1 123 456 7890)";
          }
        }
        break;

      case "Subject":
        if (!value || value === "Select") {
          error = "Please select a subject";
        }
        break;

      case "Message":
        if (!value.trim()) {
          error = "Message is required";
        } else if (value.trim().length < 10) {
          error = "Message must be at least 10 characters";
        } else if (value.trim().length > 500) {
          error = "Message cannot exceed 500 characters";
        }
        break;

      case "AgreeToTerms":
        if (!value) {
          error = "You must agree to the Privacy Policy and Terms and Conditions";
        }
        break;

      default:
        break;
    }

    return error;
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    Object.keys(form).forEach((field) => {
      const error = validateField(field, form[field]);
      if (error) {
        newErrors[field] = error;
        isValid = false;
      } else {
        newErrors[field] = "";
      }
    });

    setErrors(newErrors);
    return isValid;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;
    setForm((prev) => ({ ...prev, [name]: fieldValue }));

    // Clear error for this field as user types
    if (errors[name] && showAllErrors) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Show all errors on submit
    setShowAllErrors(true);

    // Validate entire form
    if (!validateForm()) {
      // Scroll to first error
      const firstErrorField = Object.keys(errors).find((field) => errors[field]);
      if (firstErrorField) {
        const element = document.getElementById(firstErrorField);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }
      return;
    }

    postSupportRequest(form)
      .then(({ data }) => {
        if (data.Status) {
          setShowModal(true);
        } else {
          alert("Failed to submit the ticket. Please try again.");
        }
      })
      .catch(() => {
        alert("An error occurred while submitting the ticket. Please try again.");
      });

    // Reset form
    setForm({
      Name: "",
      Email: "",
      PhoneNumber: "",
      Subject: "",
      Message: "",
    });

    setErrors({
      Name: "",
      Email: "",
      PhoneNumber: "",
      Subject: "",
      Message: "",
    });

    setShowAllErrors(false);

    alert("Thank you for your message! We'll get back to you soon.");
  };

  const handleCancelSubmit = () => {
    setShowModal(false);
    // User cancelled, do nothing
  };

  // Helper function to check if field should show error
  const shouldShowError = (fieldName) => {
    return showAllErrors && errors[fieldName];
  };

  return (
    <section id="support-section">
      <img className="contact-cta" src={contactImg} />
      <div className="wrapper">
        <div className="contact-container">
          <Row className="support-row me-0 ms-0 contactUs-row">
            {/* Left contact panel */}
            <Col md={4} className="left-panel-col pe-0 ps-0">
              <div className="left-panel left-side">
                <div className="contact-box left-header">
                  {/* <h3 className="say-hello">Say Hello</h3> */}
                  <img className="helo-img" src={sayHelo} />
                  <h1 className="heading">WE’d love to hear from you</h1>
                  <p className="para">Whether you have a question, suggestion, or just want to say hello — we’re here for you.</p>
                </div>
                <div className="contact-box customer-services">
                  <h3 className="servi-head">Customer Service</h3>
                  <div className="servi-contact">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="#603A16">
                        <path d="M21 16.42V19.9561C21 20.4811 20.5941 20.9167 20.0705 20.9537C19.6331 20.9846 19.2763 21 19 21C10.1634 21 3 13.8366 3 5C3 4.72371 3.01545 4.36687 3.04635 3.9295C3.08337 3.40588 3.51894 3 4.04386 3H7.5801C7.83678 3 8.05176 3.19442 8.07753 3.4498C8.10067 3.67907 8.12218 3.86314 8.14207 4.00202C8.34435 5.41472 8.75753 6.75936 9.3487 8.00303C9.44359 8.20265 9.38171 8.44159 9.20185 8.57006L7.04355 10.1118C8.35752 13.1811 10.8189 15.6425 13.8882 16.9565L15.4271 14.8019C15.5572 14.6199 15.799 14.5573 16.001 14.6532C17.2446 15.2439 18.5891 15.6566 20.0016 15.8584C20.1396 15.8782 20.3225 15.8995 20.5502 15.9225C20.8056 15.9483 21 16.1633 21 16.42Z"></path>
                      </svg>
                    </span>
                    <a className="para" href="tel:+18025554321">(802) 555-4321</a>
                  </div>
                  <div className="servi-contact">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="#603A16">
                        <path d="M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM12.0606 11.6829L5.64722 6.2377L4.35278 7.7623L12.0731 14.3171L19.6544 7.75616L18.3456 6.24384L12.0606 11.6829Z"></path>
                      </svg>
                    </span>
                    <span className="para">hello@mainsstore.com</span>
                  </div>
                  <h3 className="servi-head mt-3">Address</h3>
                  <div className="servi-contact">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="#603A16">
                        <path d="M12 20.8995L16.9497 15.9497C19.6834 13.2161 19.6834 8.78392 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.31658 8.78392 4.31658 13.2161 7.05025 15.9497L12 20.8995ZM12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364L12 23.7279ZM12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13Z"></path>
                      </svg>
                    </span>
                    <span className="para location">1234 Maplewood Drive Springfield, VT 05156</span>
                  </div>
                  <a href="https://share.google/9lqJRYSi6i52639Km" target="_blank" rel="noopener noreferrer" className="location-button">
                    find location
                  </a>
                </div>

                {/* <div className="contact-box">
                  <div className="contact-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="rgba(196,48,62,1)">
                      <path d="M21 16.42V19.9561C21 20.4811 20.5941 20.9167 20.0705 20.9537C19.6331 20.9846 19.2763 21 19 21C10.1634 21 3 13.8366 3 5C3 4.72371 3.01545 4.36687 3.04635 3.9295C3.08337 3.40588 3.51894 3 4.04386 3H7.5801C7.83678 3 8.05176 3.19442 8.07753 3.4498C8.10067 3.67907 8.12218 3.86314 8.14207 4.00202C8.34435 5.41472 8.75753 6.75936 9.3487 8.00303C9.44359 8.20265 9.38171 8.44159 9.20185 8.57006L7.04355 10.1118C8.35752 13.1811 10.8189 15.6425 13.8882 16.9565L15.4271 14.8019C15.5572 14.6199 15.799 14.5573 16.001 14.6532C17.2446 15.2439 18.5891 15.6566 20.0016 15.8584C20.1396 15.8782 20.3225 15.8995 20.5502 15.9225C20.8056 15.9483 21 16.1633 21 16.42Z"></path>
                    </svg>
                  </div>
                  <div className="contact-info">
                    <div className="contact-title">Call Us</div>
                    <div className="contact-sub">Speak directly with our team</div>
                    <div className="contact-phone">(802) 555-4321</div>
                  </div>
                </div>

                <div className="contact-box mt-3">
                  <div className="contact-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="rgba(196,48,62,1)">
                      <path d="M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM12.0606 11.6829L5.64722 6.2377L4.35278 7.7623L12.0731 14.3171L19.6544 7.75616L18.3456 6.24384L12.0606 11.6829Z"></path>
                    </svg>
                  </div>
                  <div className="contact-info">
                    <div className="contact-title">Email Us</div>
                    <div className="contact-sub">We'll respond within 24 hours</div>
                    <div className="contact-phone">support@mainscountry.com</div>
                  </div>
                </div> */}

                {/* <div className="contact-box mt-3">
                  <div className="contact-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="rgba(196,48,62,1)">
                      <path d="M12 20.8995L16.9497 15.9497C19.6834 13.2161 19.6834 8.78392 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.31658 8.78392 4.31658 13.2161 7.05025 15.9497L12 20.8995ZM12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364L12 23.7279ZM12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13Z"></path>
                    </svg>
                  </div>
                  <div className="contact-info">
                    <div className="contact-title">Visit Us</div>
                    <div className="contact-sub">Come see us in person</div>
                    <div className="contact-phone">123 Main Street, Anytown, USA</div>
                  </div>
                </div> */}
              </div>
            </Col>

            {/* Right form card */}
            <Col md={8} className="card-supp">
              <div className="support-card">
                <CardBody className="support-card-body p-4 p-md-5" id="contact-card-body">
                  <div className="support-card-header">
                    <h3 className="card-title">Fill out the form, Our team will reach out to you as soon as possible.</h3>
                    <p className="card-sub">
                      Fields marked with <span className="required-asterisk">*</span> are mandatory.
                    </p>
                  </div>

                  <Form onSubmit={handleSubmit} className="support-form" noValidate>
                    <div className="mt-5 mb-5">
                      <Row className="pe-0 ps-0">
                        <Col md={6}>
                          <FormGroup>
                            <Label for="Name">
                              Full Name <span className="required-asterisk">*</span>
                            </Label>
                            <Input
                              id="Name"
                              name="Name"
                              value={form.Name}
                              onChange={handleChange}
                              className={shouldShowError("Name") ? "is-invalid" : ""}
                              placeholder="Enter your name"
                              maxLength={60}
                            />
                            {shouldShowError("Name") && <div className="invalid-feedback d-block">{errors.Name}</div>}
                          </FormGroup>
                        </Col>

                        <Col md={6}>
                          <FormGroup>
                            <Label for="Email">
                              Email Address <span className="required-asterisk">*</span>
                            </Label>
                            <Input
                              id="Email"
                              name="Email"
                              type="email"
                              value={form.Email}
                              onChange={handleChange}
                              className={shouldShowError("Email") ? "is-invalid" : ""}
                              placeholder="Enter your email"
                              maxLength={100}
                            />
                            {shouldShowError("Email") && <div className="invalid-feedback d-block">{errors.Email}</div>}
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row className="pe-0 ps-0">
                        <Col md={6}>
                          <FormGroup>
                            <Label for="phone">
                              Phone Number <span className="required-asterisk">*</span>
                            </Label>
                            <Input
                              id="PhoneNumber"
                              name="PhoneNumber"
                              value={form.PhoneNumber}
                              onChange={handleChange}
                              className={shouldShowError("PhoneNumber") ? "is-invalid" : ""}
                              placeholder="e.g., 123-456-7890, (123) 456-7890"
                              maxLength={20}
                            />
                            {shouldShowError("PhoneNumber") && <div className="invalid-feedback d-block">{errors.PhoneNumber}</div>}
                          </FormGroup>
                        </Col>

                        <Col md={6}>
                          <FormGroup>
                            <Label for="Subject">
                              Subject <span className="required-asterisk">*</span>
                            </Label>
                            <div className="select-wrapper position-relative">
                              <Input
                                type="select"
                                id="Subject"
                                name="Subject"
                                value={form.Subject}
                                onChange={handleChange}
                                className={`custom-select ${shouldShowError("Subject") ? "is-invalid" : ""}`}
                              >
                                {subjectOptions.map((s, i) => (
                                  <option key={i} value={i === 0 ? "" : s}>
                                    {s}
                                  </option>
                                ))}
                              </Input>
                              <div className="select-arrow">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  width="16"
                                  height="16"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <polyline points="6 9 12 15 18 9"></polyline>
                                </svg>
                              </div>
                            </div>
                            {shouldShowError("Subject") && <div className="invalid-feedback d-block">{errors.Subject}</div>}
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row className="pe-0 ps-0">
                        <Col md={12}>
                          <FormGroup>
                            <Label for="Message">
                              Additional Information <span className="required-asterisk">*</span>
                              <span className="char-count">{form.Message.length}/500</span>
                            </Label>
                            <Input
                              type="textarea"
                              id="Message"
                              name="Message"
                              value={form.Message}
                              onChange={handleChange}
                              className={shouldShowError("Message") ? "is-invalid" : ""}
                              placeholder="How can we help you?"
                              rows={5}
                              maxLength={500}
                            />
                            {shouldShowError("Message") && <div className="invalid-feedback d-block">{errors.Message}</div>}
                            <small className="text-muted d-block mt-1">Minimum 10 characters required</small>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row className="pe-0 ps-0 mt-2">
                        <Col md={12}>
                          <div className="checkbox">
                            <FormGroup check className="mb-3">
                              <Input
                                type="checkbox"
                                id="AgreeToTerms"
                                name="AgreeToTerms"
                                checked={form.AgreeToTerms}
                                onChange={handleChange}
                                className={shouldShowError("AgreeToTerms") ? "is-invalid" : ""}
                              />
                              <Label check for="AgreeToTerms" className="ms-2">
                                By accepting this, I agree to the{" "}
                                <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
                                  Privacy Policy
                                </a>{" "}
                                and{" "}
                                <a href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">
                                  Terms and Conditions
                                </a>
                                .<span className="required-asterisk ms-1">*</span>
                              </Label>
                              {shouldShowError("AgreeToTerms") && <div className="invalid-feedback d-block">{errors.AgreeToTerms}</div>}
                            </FormGroup>

                            <FormGroup check>
                              <Input
                                type="checkbox"
                                id="SubscribeToNewsletter"
                                name="SubscribeToNewsletter"
                                checked={form.SubscribeToNewsletter}
                                onChange={handleChange}
                              />
                              <Label check for="SubscribeToNewsletter" className="ms-2">
                                Subscribe me to the newsletter for the latest offers and updates.
                              </Label>
                            </FormGroup>
                          </div>
                        </Col>
                      </Row>
                    </div>

                    <div className="w-100">
                      <button type="submit" className="submit-button w-100">
                        SEND MESSAGE
                      </button>
                    </div>
                  </Form>
                </CardBody>
              </div>
            </Col>
          </Row>
        </div>
        <ConfirmationModal
          isOpen={showModal}
          toggle={() => setShowModal(false)}
          type="confirmation"
          title="Message Sent"
          message={`Your message has been sent. Our team will get back to you shortly.`}
          ButtonText="Back to Contact Us"
          onCancel={handleCancelSubmit}
        />
      </div>
    </section>
  );
};

export default ContactUs;
